/* eslint-disable no-underscore-dangle */
import React from 'react';

import {
  NodeKey,
  DecoratorNode,
  SerializedLexicalNode,
  LexicalEditor,
} from 'lexical';

import { PlayerComponent } from '../../plugins';

import { $createVideoNode } from './VideoNode.helpers';

type SerializedVideoLinkNode = SerializedLexicalNode & {
  type: 'video';
  version: 1;
  src: string;
  description?: string;
};

export class VideoNode extends DecoratorNode<React.ReactNode> {
  src: string;

  description: string | undefined;

  static getType(): string {
    return 'video';
  }

  static clone(node: VideoNode): VideoNode {
    return new VideoNode(node.src, node.description, node.__key);
  }

  constructor(src: string, description?: string, key?: NodeKey) {
    super(key);
    this.src = src;
    this.description = description;
  }

  createDOM(): HTMLElement {
    return document.createElement('span');
  }

  decorate(editor: LexicalEditor): React.ReactNode {
    return (
      <PlayerComponent
        src={this.src}
        description={this.description}
        editable={editor._editable}
      />
    );
  }

  exportJSON(): SerializedVideoLinkNode {
    return {
      ...super.exportJSON(),
      type: 'video',
      version: 1,
      src: this.src,
      description: this.description,
    };
  }

  static importJSON(serializedNode: SerializedVideoLinkNode): VideoNode {
    return $createVideoNode(
      serializedNode.src,
      serializedNode.description,
    ).updateFromJSON(serializedNode);
  }

  getTextContent(): string {
    return this.description || '';
  }
}
